<template>
  <div>
    <delete-modal
      :yesFunc="deleteItem"
      ref="deleteModalRef"
      :description="$t('description.deleteContent')"
      :title="$t('title.deleteContentTitle')"
    />

    <v-dialog persistent v-model="editModal" max-width="1200">
      <v-card>
        <v-card-title class="headline indigo lighten-2">
          <div class="text-center white--text" style="width: 100%">
            {{ $t(`buttons.update`) }}
          </div>
        </v-card-title>

        <!-- PREVIEW -->
      <!-- PREVIEW -->
    <v-sheet
      class="ma-4 pa-4 rounded-lg"
      color="#FAFAFA"
      outlined
    >
      <v-row dense>
        
        <!-- IMAGE -->
        <v-col
          cols="12"
          md="4"
          v-if="activeImageURLs.length > 0"
        >
          <div
            class="rounded-lg overflow-hidden"
            style="
              border: 1px solid #EEEEEE;
              background: white;
            "
          >
            <v-carousel
              height="220"
              hide-delimiter-background
              :show-arrows="activeImageURLs.length > 1"
              delimiter-icon="mdi-minus"
            >
              <v-carousel-item
                v-for="(image, index) in activeImageURLs"
                :key="index"
              >
                <v-img
                  :src="image"
                  contain
                  height="220"
                  class="grey lighten-5"
                />
              </v-carousel-item>
            </v-carousel>
          </div>
        </v-col>

        <!-- CONTENT -->
        <v-col
          cols="12"
          :md="activeImageURLs.length > 0 ? 8 : 12"
        >
          <div class="d-flex flex-column fill-height">

            <!-- TOP -->
            <div class="d-flex justify-space-between align-start">
              
              <div class="pr-4">
                <!-- TITLE -->
                <div
                  class="font-weight-bold"
                  style="
                    font-size: 24px;
                    line-height: 1.35;
                    color: #212121;
                  "
                >
                  {{ editForm.Title }}
                </div>

                <!-- ID -->
                <div
                  class="mt-1"
                  style="
                    font-size: 12px;
                    color: #9E9E9E;
                  "
                >
                  İlan No: #{{ editForm.Id }}
                </div>
              </div>

              <!-- STATUS -->
              <v-chip
                small
                label
                class="font-weight-bold"
                :style="{
                  backgroundColor:
                    statusMap[editForm.ListingStatus]?.color,
                  color:
                    statusMap[editForm.ListingStatus]?.textColor,
                  border: '1px solid rgba(0,0,0,0.05)'
                }"
              >
                {{ statusMap[editForm.ListingStatus]?.text }}
              </v-chip>
            </div>

            <!-- PRICE -->
            <div
              class="font-weight-black mt-4"
              style="
                font-size: 32px;
                color: #2E7D32;
                letter-spacing: -0.5px;
              "
            >
              ₺ {{ Number(editForm.Price || 0).toLocaleString("tr-TR") }}
            </div>

            <!-- DESCRIPTION -->
            <div
              class="mt-4 pa-4 rounded-lg"
              style="
                background: white;
                border: 1px solid #EEEEEE;
                color: #424242;
                line-height: 1.7;
                min-height: 110px;
                max-height: 180px;
                overflow-y: auto;
                white-space: pre-line;
              "
            >
              {{ editForm.Description || "-" }}
            </div>

          </div>
        </v-col>

      </v-row>
    </v-sheet>

    <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-card-text class="align-center">
          <StatusSelect
            :label="$t('labels.status')"
            :data="statusItems"
            hide-details
            style="min-width: 180px"
            item-text="label"
            item-value="value"
            prepend-icon="mdi-filter-cog"
            v-model="editForm.ListingStatus"
            :rules="{ required: true }"
          />
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
            small
            class="ma-2 mr-4"
            type="submit"
            elevation="0"
            large
            outlined
            color="red"
          >
            {{ $t(`buttons.update`) }}
          </v-btn>

          <v-btn
            small
            class="ma-2 mr-4"
            elevation="0"
            large
            outlined
            color="grey"
            @click="editModal = false"
          >
            {{ $t("buttons.cancel") }}
          </v-btn>
        </v-card-actions>
      </form>
    </ValidationObserver>
  </v-card>
</v-dialog>

    <v-card style="border-radius: 10px">
      <v-card-title style="color: #595959">
       <v-row align="center" justify="space-between">
          <v-col cols="auto">
            <div class="text-h6">
              İlanlar
            </div>
          </v-col>

          <!-- <v-col cols="auto">
            <v-btn
              @click="() => {}"
              small
              elevation="0"
              outlined
              color="var(--primary-color)"
            >
              <v-icon left small>mdi-plus</v-icon>
              {{ $t("buttons.addNew") }}
            </v-btn>
          </v-col> -->
        </v-row>
      </v-card-title>

      <v-divider />

      <v-card-text>
        <v-row class="mb-4" align="center">
          <v-col cols="2">
            <StatusSelect 
              :label="$t('labels.status')"
              :data="statusItems"
              clearable
              hide-details
              style="min-width: 180px"
              item-text="label"
              item-value="value"
              prepend-icon="mdi-filter-cog"
              v-model="filters.Status"
              @change="pagination.page = 1; getTableList()"
            />
          </v-col>
          <v-col cols="2">
            <v-menu v-model="datePickerVisible" :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  :label="$t('labels.startDate')"
                  prepend-icon="mdi-calendar"
                  readonly
                  hide-details
                  v-bind="attrs"
                  v-on="on"
                  style="fontSize: 11px;"
                />
              </template>
              <v-date-picker v-model="minimumDate" locale="tr-TR">
                <v-spacer />
                <v-btn text color="primary" @click="clearDateFilter">
                  {{ $t(`buttons.${minimumDate?.length > 0 ? 'clear' : 'cancel'}`) }}
                </v-btn>
                <v-btn text color="primary" @click="applyDateFilter">
                  {{ $t("buttons.ok") }}
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <!-- <v-col cols="auto" class="ml-auto">
            <v-text-field
              v-model="filters.Search"
              append-icon="mdi-magnify"
              @click:append="getTableList"
              :label="$t('labels.search')"
              v-on:keyup.enter="getTableList"
              @click:clear="filters.Search = ''; getTableList()"
              clear-icon="mdi-close-circle"
              clearable
              single-line
              hide-details
              style="min-width: 250px"
            />
          </v-col> -->
        </v-row>

        <v-row class="mb-4" v-if="selectedPostsCount > 0">
          <v-col cols="12">
            <v-divider  class="mb-4" />
            {{ selectedPostsCount }} adet gönderi seçildi.
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="quickUpdateStatus"
              :items="[
                { label: 'Sil', value: 'delete' },
                { label: 'Düzenle', value: 'update' }
              ]"
              :label="$t('labels.action')"
              clearable
              hide-details
              style="min-width: 180px"
              item-text="label"
              item-value="value"
            />
          </v-col>
          <!-- UPDATE seçilince ikinci select -->
          <v-col cols="3" v-if="quickUpdateStatus === 'update'">
            <StatusSelect
              v-model="updateStatusValue"
              :items="statusItems"
              label="Durum"
              clearable
              hide-details
              :inactiveValues="[null, 30]"
              style="min-width: 180px"
              item-text="label"
              item-value="value"
            />
          </v-col>
          <v-col cols="3" v-if="canApplyBulkUpdate">
            <v-btn
              small
              class="ma-4 mr-8"
              elevation="0"
              outlined
              color="info"
              @click="bulkUpdate()"
            >
              {{ $t('buttons.apply') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          @click:row="getDetails"
          :item-class="() => 'clickable-row'"
          :headers="headers"
          :items="tableData"
          :loading="loadings.table"
          :options.sync="pagination"
          :hide-default-footer="true"
          :footer-props="{
            disablePagination: true,
            disableItemsPerPage: true,
          }"
          :no-data-text="$t('description.noList')"
     
        >
          <template v-slot:item.IdentityNumber="{ item }">
            {{ item?.OwnerUsername }}
          </template>
          <template v-slot:item.Creator="{ item }">
            {{ item?.OwnerName && item?.OwnerSurname ? `${item.OwnerName} ${item.OwnerSurname}` : '-' }}
          </template>
          <template v-slot:item.Status="{ item }">
            <div style="font-weight: bold !important;">
              <v-chip :color="statusMap[item.ListingStatus].color">
                <span :style="{ color: statusMap[item.ListingStatus].textColor }">
                  {{ statusMap[item.ListingStatus].text }}
                </span>
              </v-chip>
            </div>
          </template>
          <template v-slot:item.CreatedAt="{ item }">
            {{ convertToLocal(item.CreatedAt) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  @click.stop="getDetails(item)"
                  v-bind="attrs"
                  v-on="on"
                  color="info"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>{{ $t("labels.tooltipEdit") }}</span>
            </v-tooltip>
            <!-- <v-tooltip top >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="ml-2"
                  small
                  @click.stop="publishOperation(item, 20)"
                  v-bind="attrs"
                  v-on="on"
                  style="color: green !important;"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>{{ $t("labels.view") }}</span>
            </v-tooltip> -->
            <!-- <v-tooltip top v-if="item.Status === 10">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  @click.stop="copy(item?.Id)"
                  v-bind="attrs"
                  v-on="on"
                  style="color: #006A99 !important;"
                >
                  mdi-content-duplicate
                </v-icon>
              </template>
              <span>{{ $t("buttons.copy") }}</span>
            </v-tooltip>
            <v-tooltip top v-if="item.Status !== 10">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  @click.stop="publishOperation(item, 10)"
                  v-bind="attrs"
                  v-on="on"
                  color="sucess"
                >
                  mdi-publish
                </v-icon>
              </template>
              <span>{{ $t("labels.publishItem") }}</span>
            </v-tooltip>
            <v-tooltip top v-if="item.Status !== 30">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="error"
                  small
                  @click.stop="publishOperation(item, 30)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>{{ $t("labels.tooltipDelete") }}</span>
            </v-tooltip> -->
          </template>
        </v-data-table>
        <v-row class="my-2">
          <v-spacer />

          <v-col cols="3">
            <v-select
              v-model="pagination.itemsPerPage"
              :items="perPageValues"
              :label="$t('labels.selectItemsPerPage')"
              item-value="value"
              item-text="name"
              @change="getTableList"
            />
          </v-col>
        </v-row>
        <div class="text-xs-center pt-2 md4 lg4" v-if="this.pagination.totalItems">
          <v-pagination
            @input="paginationChangeHandler"
            :value="pagination.page"
            :length="pages"
            :total-visible="10"
            circle
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ContentService from "../services/ContentService";
import ModuleService from "../services/ModuleService";
import PostService from "../services/PostService";
import CategoryService from "../services/CategoryService";
import DeleteModal from "../components/General/DeleteModal";
import StatusSelect from "../components/StatusSelect.vue";
import dayjs from "dayjs";
import ListingService from "../services/ListingService";
import FileService from "../services/FileService";

export default {
  data: () => ({
    editForm: {
      ListingStatus: null
    },
    editModal: false,
    statusItems: [
      {
        label: "Onay Bekliyor",
        value: 0
      },
      {
        label: "Onaylandı",
        value: 1
      },
      {
        label: "Reddedildi",
        value: 2
      },
      {
        label: "Yayınlanmadı",
        value: 3
      },
    ],

    quickUpdateStatus: null,
    updateStatusValue: null,
    selectedItems: [],
    statusMap: {
      0: {
        text: "Onay Bekliyor",
        color: "#FFF3CD",      // soft sarı (bekliyor)
        textColor: "#856404"
      },
      1: {
        text: "Onaylandı",
        color: "#D4EDDA",      // yeşil (başarılı)
        textColor: "#155724"
      },
      2: {
        text: "Reddedildi",
        color: "#F8D7DA",      // kırmızı ton (hata/ret)
        textColor: "#721C24"
      },
      3: {
        text: "Yayında Değil",
        color: "#F8D7DA",      // kırmızı ton (hata/ret)
        textColor: "#721C24"
      },
    },
    //List options
    options: {
      itemsPerPage: 15,
    },
    top: 15,
    skip: 0,
    tableData: [],
    key: "",
    //Table contents
    headers: [],

    //Page loaders
    loadings: {
      table: false,
      send: false,
    },

    //Page detail
    moduleDetail: {},

    //delete model item
    deleteItemModel: {},

    search: "",
    //Pagination models
    pagination: {
      itemsPerPage: 15,
      page: 1,
      totalItems: 0
    },
    itemsPerPage: 15,
    perPageValues: [10, 15, 30, 50, 100],
    pageHeader: "",
    pageId: -1,
    moduleDescription: "",
    //Page restrictions
    pageRules: null,
    selectedCategoriesModal: [],
    categoryData: [],
    searchCategory: "",

    filters: {
      Status: null,
      Search: ""
    },

    minimumDate: "",
    datePickerVisible: false,
  }),
  watch: {},
  beforeMount() {
    this.pageRules = getPageRulesById(this.$route.params.id);
    this.moduleDetail = {
      Name: this.pageRules.adi,
      Key: this.pageRules.key
    }
  },
  mounted() {
    this.setup();
    this.getModuleDetail();
  },
  components: {
    StatusSelect,
    DeleteModal,
  },
  computed: {
    activeImageURLs(){
      const imageIds = this.editForm.ImageFileIds;
      let imageURLs = [];
      if(Array.isArray(imageIds) && imageIds.length > 0){
        imageURLs = imageIds.map(imageId => FileService.getFileString(imageId));
      }

      return imageURLs;
    },
    canApplyBulkUpdate(){
      let canApply = false;

      if(this.quickUpdateStatus === "delete") canApply = true;
      else if(this.quickUpdateStatus === "update" && this.updateStatusValue !== undefined && this.updateStatusValue !== null) canApply = true;
      
      return canApply;
    },
    selectedPostsCount(){
      return this.selectedItems.length || 0;
    },
    dateRangeText() {
      return this.minimumDate ? dayjs(this.minimumDate).format('DD.MM.YYYY') : ""
    },
        
    totalRecords() {
      return this.items.length;
    },
    pageCount() {
      return this.totalRecords / this.itemsPerPage;
    },
    pages() {
      if (
        this.pagination.itemsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.itemsPerPage
      );
    },

    filter() {
      return this.true
        ? (item, searchCategory, textKey) =>
            item[textKey].indexOf(searchCategory) > -1
        : undefined;
    },
  },
  methods: {
    submitForm(){
      const { Id, ListingStatus } = this.editForm;

      this.$store.state.loadingStatus = true;
      ListingService.updateStatus({ Id, Status: ListingStatus })
      .then(() => {
        window.showSuccess('İlan durumu başarılı bir şekilde güncellendi.')
        this.getTableList()
      })
      .catch(window.showError)
      .finally(() => this.$store.state.loadingStatus = false)
    },

    bulkUpdate(){
      let status = null;

      if(this.quickUpdateStatus === "delete"){
        status = 30;
      }
      else if(this.quickUpdateStatus === "update"){
        status = this.updateStatusValue;
      }

      if(status === null || status === undefined) return;

      const items = this.selectedItems.flatMap(item => item.Id);

      if(Array.isArray(items) && items.length > 0){
        this.$store.state.loadingStatus = true;
        PostService.bulkUpdate(items, status)
        .then(() => {
          window.showSuccess("Verileriniz başarılı bir şekilde güncellendi.")
          this.getTableList()
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        })
      }
      
    },
    copy(postId){
      this.$store.state.loadingStatus = true;
      PostService.copyPost(Number(postId))
      .then(response => {
        const data = response?.data;
        if(data?.Id){
          this.$router.push({
            path: `/home/updateContent/${data.Id}`,
            query: {
              pageName: this.pageHeader || "",
              moduleDescription: data.Description || "",
              pageId: data.Key || -1,
            },
          });
        }
      })
      .catch(window.showError)
      .finally(() => {
        this.$store.state.loadingStatus = false;
      })
    },

    clearDateFilter() {
      this.minimumDate = null;
      this.datePickerVisible = false;
      this.getTableList();
    },
    applyDateFilter() {
      this.datePickerVisible = false;
      this.getTableList()
    },
    
    tableTitle(item) {
      return item.Content <= 0 ? "İçeriksiz Gönderi" : item.Content;
    },

    async setup() {
      this.headers = [
        { text: "Başlık", value: "Title", sortable: false },
        { text: "Sicil Numarası", value: "IdentityNumber", sortable: false },
        { text: "Ekleyen", value: "Creator", sortable: false },
        
        { text: "Oluşturulma Tarihi", value: "CreatedAt", sortable: false },
        { text: "Durumu", value: "Status", sortable: false },
        { text: "İşlem", value: "actions", sortable: false },
      ];
      await this.getCategories();
    },
    async getCategories() {
      return new Promise(async (resolve, reject) => {
        try {
          if (this.pageRules.categoryIds.length > 0) {
            await Promise.all(
              this.pageRules.categoryIds.map(async (element, index) => {
                await CategoryService.getCategoriesInTreeView(element.id)
                  .then((res) => {
                    this.categoryData = this.categoryData.concat(res.data);
                  })
                  .catch((err) => {
                    window.handleServiceError(res, err);
                  })
                  .then(() => {});
              })
            );
          }
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    //Change list pagination page
    paginationChangeHandler(pageNumber) {
      this.pagination.page = pageNumber;
      this.getTableList();
    },
    //Loads page detail
    getModuleDetail() {
      // FIXME: Böyle bir yer yok.
      this.getTableList();
      return;
      ModuleService.getModuleDetails(this.$route.params.id)
        .then((res) => {
          this.moduleDetail = res.data;
          console.log("MODULE DETAIL > ", this.moduleDetail);
          this.pageId = this.moduleDetail.Id;
          this.moduleDescription = res.data.LongDescription;
          this.key = res.data.Key;

          this.getTableList();
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .then(() => {});
    },

    getTableList(categoryId = "", flag = false) {
      if (flag) 
        this.loadings.table = true;
      else 
        this.$store.state.loadingStatus = true;

      let params = {};
      if (!flag) {
        params = {
          Key: this.moduleDetail.Key,
          PageSize: this.pagination.itemsPerPage,
          Page: this.pagination.page,
        };
      } else if (flag && categoryId) {
        params = {
          CategoryIds: categoryId,
          Key: this.moduleDetail.Key,
          PageSize: this.pagination.itemsPerPage,
          Page: this.pagination.page,
        };
      }

      if(this.minimumDate){
        params['StartDate'] = this.minimumDate;
      }

      params = { ...params, ...this.filters };

      this.tableData = [];
      ListingService.getListings(params)
        .then((res) => {
          const data = res.data;
          const list = data?.Data || [];

          if(list?.length > 0){
            this.tableData = list
            this.pagination.totalItems = data?.TotalData;
          }
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .finally(() => {
          if (flag) {
            this.loadings.table = false;
          } else if (!flag) {
            this.$store.state.loadingStatus = false;
          }
        });
    },

    getCompanyNames(item) {
      let tempString = "";
      item.Groups.forEach((element) => {
        tempString += element.Name + "<br/>";
      });
      return tempString;
    },

    getDetails(item) {
      this.editForm = Object.assign({}, item);
      this.editModal = true;
    },

    openDeleteModal(item) {
      this.deleteItemModel = item;
      this.$refs.deleteModalRef.modalStatus = true;
    },
    
    deleteItem() {
      this.$store.state.loadingStatus = true;
      PostService.deletePost(this.deleteItemModel.Id)
        .then(() => {
          this.getTableList();
          this.$refs.deleteModalRef.modalStatus = false;
        })
        .catch(window.handleServiceError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        })
    },

    publishOperation(item, status) {
      let body = {
        Id: item.Id,
        Status: status
      };

      this.$store.state.loadingStatus = true;
      ContentService.changeContentStatus(body)
        .then(() => {
          item.Status = body.Status;
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    selectOneCategory(selectedCategory) {
      if (selectedCategory.length > 0) {
        console.log("Selected cat value > ", selectedCategory[0]);
        this.getTableList(selectedCategory[0].Id, true);
      } else {
        console.log("Boş table list");
        this.getTableList();
      }
    },
  },
};
</script>
<style>
.clickable-row {
  cursor: pointer !important;
}
</style>